import React from "react";

/**
 * Slow editorial marquee – single infinite line.
 * More discreet: smaller type, slower motion, thinner strip.
 */
const items = [
    "Chatbot AI",
    "Registri digitali",
    "Scadenze",
    "Formazione",
    "Sorveglianza sanitaria",
    "Sopralluoghi",
    "HACCP",
    "Dossier ASL",
    "Documenti digitali",
    "Adempimenti",
    "Calendario",
    "Consulenza agentica",
];

export default function Marquee() {
    const line = [...items, ...items];
    return (
        <section aria-hidden className="bg-navy-950 text-white py-4 md:py-5 border-y border-white/5">
            <div className="marquee-mask overflow-hidden">
                <div className="flex whitespace-nowrap will-change-transform" style={{ animation: "marquee 60s linear infinite" }}>
                    {line.map((it, i) => (
                        <span key={i} className="inline-flex items-center gap-4 px-4">
                            <span className="font-display font-semibold text-[16px] md:text-[22px] leading-none tracking-tight text-white/85">{it}</span>
                            <span className="text-gold-400/70 text-base md:text-lg">✦</span>
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
}
